var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import connectToParent from 'penpal/lib/connectToParent';
import { isOnBootParent, isRenderAssetSourceParent, isRenderConfigScreenParent, isRenderFieldExtensionParent, isRenderItemFormOutletParent, isRenderManualFieldExtensionConfigScreenParent, isRenderModalParent, isRenderPageParent, isRenderSidebarPanelParent, isRenderSidebarParent, } from './guards';
function toMultifield(fn) {
    return function (fields, ctx) {
        if (!fn) {
            return {};
        }
        var result = {};
        for (var _i = 0, fields_1 = fields; _i < fields_1.length; _i++) {
            var field = fields_1[_i];
            var itemType = ctx.itemTypes[field.relationships.item_type.data.id];
            result[field.id] = fn(field, __assign(__assign({}, ctx), { itemType: itemType }));
        }
        return result;
    };
}
function getMaxScrollHeight() {
    var elements = document.querySelectorAll('body *');
    var maxVal = 0;
    for (var i = 0; i < elements.length; i++) {
        maxVal = Math.max(elements[i].getBoundingClientRect().bottom, maxVal);
    }
    return maxVal;
}
var buildRenderUtils = function (parent) {
    var oldHeight = null;
    var updateHeight = function (height) {
        var realHeight = height === undefined
            ? Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.getBoundingClientRect().height, getMaxScrollHeight())
            : height;
        if (realHeight !== oldHeight) {
            parent.setHeight(realHeight);
            oldHeight = realHeight;
        }
    };
    var resizeObserver = null;
    var mutationObserver = null;
    var onMutation = function () { return updateHeight(); };
    var startAutoResizer = function () {
        updateHeight();
        if (!resizeObserver) {
            resizeObserver = new ResizeObserver(onMutation);
            resizeObserver.observe(document.documentElement);
        }
        if (!mutationObserver) {
            mutationObserver = new MutationObserver(onMutation);
            mutationObserver.observe(window.document.body, {
                attributes: true,
                childList: true,
                subtree: true,
                characterData: true,
            });
        }
    };
    var stopAutoResizer = function () {
        if (resizeObserver) {
            resizeObserver.disconnect();
            resizeObserver = null;
        }
        if (mutationObserver) {
            mutationObserver.disconnect();
            mutationObserver = null;
        }
    };
    var isAutoResizerActive = function () { return Boolean(resizeObserver); };
    return {
        updateHeight: updateHeight,
        startAutoResizer: startAutoResizer,
        stopAutoResizer: stopAutoResizer,
        isAutoResizerActive: isAutoResizerActive,
    };
};
export function connect(configuration) {
    if (configuration === void 0) { configuration = {}; }
    return __awaiter(this, void 0, void 0, function () {
        var assetSources, mainNavigationTabs, settingsAreaSidebarItemGroups, contentAreaSidebarItems, manualFieldExtensions, itemFormSidebarPanels, itemFormSidebars, itemFormOutlets, listener, callMethodMergingBootCtxExecutor, penpalConnection, parent, initialSettings, currentSettings_1, render, renderUtils_1, render, renderUtils_2, render, renderUtils_3, render, renderUtils_4, render, renderUtils_5, render, renderUtils_6, render, renderUtils_7, render, renderUtils_8, render;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    assetSources = configuration.assetSources, mainNavigationTabs = configuration.mainNavigationTabs, settingsAreaSidebarItemGroups = configuration.settingsAreaSidebarItemGroups, contentAreaSidebarItems = configuration.contentAreaSidebarItems, manualFieldExtensions = configuration.manualFieldExtensions, itemFormSidebarPanels = configuration.itemFormSidebarPanels, itemFormSidebars = configuration.itemFormSidebars, itemFormOutlets = configuration.itemFormOutlets;
                    listener = null;
                    callMethodMergingBootCtxExecutor = null;
                    penpalConnection = connectToParent({
                        methods: {
                            sdkVersion: function () { return '0.2.0'; },
                            implementedHooks: function () {
                                return Object.fromEntries(Object.entries(configuration).map(function (_a) {
                                    var key = _a[0], value = _a[1];
                                    if (typeof value === 'function') {
                                        return [key, true];
                                    }
                                    return [key, value];
                                }));
                            },
                            assetSources: assetSources,
                            mainNavigationTabs: mainNavigationTabs,
                            settingsAreaSidebarItemGroups: settingsAreaSidebarItemGroups,
                            contentAreaSidebarItems: contentAreaSidebarItems,
                            manualFieldExtensions: manualFieldExtensions,
                            itemFormSidebarPanels: itemFormSidebarPanels,
                            itemFormSidebars: itemFormSidebars,
                            itemFormOutlets: itemFormOutlets,
                            overrideFieldExtensions: toMultifield(configuration.overrideFieldExtensions),
                            customMarksForStructuredTextField: toMultifield(configuration.customMarksForStructuredTextField),
                            customBlockStylesForStructuredTextField: toMultifield(configuration.customBlockStylesForStructuredTextField),
                            onChange: function (newSettings) {
                                if (listener) {
                                    listener(newSettings);
                                }
                            },
                            callMethodMergingBootCtx: function (methodName, methodArgs, extraCtx) {
                                if (!callMethodMergingBootCtxExecutor) {
                                    return null;
                                }
                                return callMethodMergingBootCtxExecutor(methodName, methodArgs, extraCtx);
                            },
                        },
                    });
                    return [4 /*yield*/, penpalConnection.promise];
                case 1:
                    parent = _a.sent();
                    return [4 /*yield*/, parent.getSettings()];
                case 2:
                    initialSettings = _a.sent();
                    if (isOnBootParent(parent, initialSettings)) {
                        currentSettings_1 = initialSettings;
                        listener = function (newSettings) {
                            currentSettings_1 = newSettings;
                        };
                        callMethodMergingBootCtxExecutor = function (methodName, methodArgs, extraCtx) {
                            var _a;
                            if (!(methodName in configuration)) {
                                return undefined;
                            }
                            return (_a = configuration)[methodName].apply(_a, __spreadArray(__spreadArray([], methodArgs, false), [__assign(__assign(__assign({}, parent), currentSettings_1), extraCtx)], false));
                        };
                        if (configuration.onBoot) {
                            configuration.onBoot(__assign(__assign({}, parent), currentSettings_1));
                        }
                    }
                    if (isRenderPageParent(parent, initialSettings)) {
                        render = function (settings) {
                            if (!configuration.renderPage) {
                                return;
                            }
                            configuration.renderPage(settings.pageId, __assign(__assign({}, parent), settings));
                        };
                        listener = render;
                        render(initialSettings);
                    }
                    if (isRenderConfigScreenParent(parent, initialSettings)) {
                        renderUtils_1 = buildRenderUtils(parent);
                        render = function (settings) {
                            if (!configuration.renderConfigScreen) {
                                return;
                            }
                            configuration.renderConfigScreen(__assign(__assign(__assign({}, parent), settings), renderUtils_1));
                        };
                        listener = render;
                        render(initialSettings);
                    }
                    if (isRenderModalParent(parent, initialSettings)) {
                        renderUtils_2 = buildRenderUtils(parent);
                        render = function (settings) {
                            if (!configuration.renderModal) {
                                return;
                            }
                            configuration.renderModal(settings.modalId, __assign(__assign(__assign({}, parent), settings), renderUtils_2));
                        };
                        listener = render;
                        render(initialSettings);
                    }
                    if (isRenderAssetSourceParent(parent, initialSettings)) {
                        renderUtils_3 = buildRenderUtils(parent);
                        render = function (settings) {
                            if (!configuration.renderAssetSource) {
                                return;
                            }
                            configuration.renderAssetSource(settings.assetSourceId, __assign(__assign(__assign({}, parent), settings), renderUtils_3));
                        };
                        listener = render;
                        render(initialSettings);
                    }
                    if (isRenderSidebarPanelParent(parent, initialSettings)) {
                        renderUtils_4 = buildRenderUtils(parent);
                        render = function (settings) {
                            if (!configuration.renderItemFormSidebarPanel) {
                                return;
                            }
                            configuration.renderItemFormSidebarPanel(settings.sidebarPaneId, __assign(__assign(__assign({}, parent), settings), renderUtils_4));
                        };
                        listener = render;
                        render(initialSettings);
                    }
                    if (isRenderSidebarParent(parent, initialSettings)) {
                        renderUtils_5 = buildRenderUtils(parent);
                        render = function (settings) {
                            if (!configuration.renderItemFormSidebar) {
                                return;
                            }
                            configuration.renderItemFormSidebar(settings.sidebarId, __assign(__assign(__assign({}, parent), settings), renderUtils_5));
                        };
                        listener = render;
                        render(initialSettings);
                    }
                    if (isRenderItemFormOutletParent(parent, initialSettings)) {
                        renderUtils_6 = buildRenderUtils(parent);
                        render = function (settings) {
                            if (!configuration.renderItemFormOutlet) {
                                return;
                            }
                            configuration.renderItemFormOutlet(settings.itemFormOutletId, __assign(__assign(__assign({}, parent), settings), renderUtils_6));
                        };
                        listener = render;
                        render(initialSettings);
                    }
                    if (isRenderFieldExtensionParent(parent, initialSettings)) {
                        renderUtils_7 = buildRenderUtils(parent);
                        render = function (settings) {
                            if (!configuration.renderFieldExtension) {
                                return;
                            }
                            configuration.renderFieldExtension(settings.fieldExtensionId, __assign(__assign(__assign({}, parent), settings), renderUtils_7));
                        };
                        listener = render;
                        render(initialSettings);
                    }
                    if (isRenderManualFieldExtensionConfigScreenParent(parent, initialSettings)) {
                        renderUtils_8 = buildRenderUtils(parent);
                        render = function (settings) {
                            if (!configuration.renderManualFieldExtensionConfigScreen) {
                                return;
                            }
                            configuration.renderManualFieldExtensionConfigScreen(settings.fieldExtensionId, __assign(__assign(__assign({}, parent), settings), renderUtils_8));
                        };
                        listener = render;
                        render(initialSettings);
                    }
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=connect.js.map